import {action} from "mobx";
import equipmentRequestService from "services/equipmentRequestService";
import appStore from "./appStore";
import {message} from "antd";
import {b64DecodeToUrl} from "utils/helpers";

class EquipmentRequestStore {
    @action listRequests = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await equipmentRequestService.listEquipmentRequests(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action createRequest = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await equipmentRequestService.createEquipmentRequest(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        message.success("Ekipman talebi başarıyla oluşturuldu");
        return true;
    };

    @action approveRequest = async params => {
        try {
            const resultOfRequest = await equipmentRequestService.approveEquipmentRequest(params);

            if (resultOfRequest.status !== 200) {
                throw new Error(resultOfRequest?.message || resultOfRequest?.data?.message);
            }
            message.success("Ekipman talebi onaylandı");
            return true;
        } catch (error) {
            appStore.openErrorModal({content: error?.message || "Ekipman talebi onaylanamadı"});
            return false;
        }
    };

    @action getRequestDetail = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await equipmentRequestService.getEquipmentRequest(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action downloadLabel = async params => {
        try {
            const resultOfRequest = await equipmentRequestService.downloadEquipmentRequestLabel(
                params
            );

            if (resultOfRequest.status !== 200) {
                throw new Error(resultOfRequest?.message || resultOfRequest?.data?.message);
            }

            const contract = resultOfRequest?.data?.contractPreviewResult?.contract;

            const base64Data = contract?.base64File;
            const blobUrl = await b64DecodeToUrl(base64Data);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.setAttribute("download", `${contract?.name}`);
            document.body.appendChild(link);
            link.click();
            link.remove();

            message.success("Çıktı başarıyla indirildi");
            return true;
        } catch (error) {
            appStore.openErrorModal({content: error?.message || "Çıktı indirilirken hata oluştu"});
            return false;
        }
    };
}

export default new EquipmentRequestStore();
